<template>
  <v-tooltip v-model="showTooltip" top>
    <template v-slot:activator="{ on }">
      <div v-on="value ? on : {}">
        <v-autocomplete
          :value="value"
          :clearable="!!!(readonly & clearable)"
          :readonly="readonly"
          :items="items"
          cache-items
          v-bind="$attrs"
          v-on="listeners"
        >
          <template v-if="readonly" v-slot:append
            ><v-icon @click="showCompany">mdi-eye</v-icon>
          </template>
          <template
            v-for="slot in Object.keys($scopedSlots)"
            v-slot:[slot]="scope"
          >
            <slot :name="slot" v-bind="scope" />
          </template>
        </v-autocomplete>
      </div>
    </template>
    <span class="tooltip-list">
      <p>{{ selectedItem.name }}</p>
      <p v-if="selectedItem.city">{{ selectedItem.city }}</p>
      <p v-if="selectedItem.zip">{{ selectedItem.zip }}</p>
      <p v-if="selectedItem.street">{{ selectedItem.street }}</p>
      <p v-if="selectedItem.phone">{{ selectedItem.phone }}</p>
    </span>
  </v-tooltip>
</template>

<script>

export default {
  name: 'CompanySelect',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    value: {
      type: Number,
      default: null
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      showTooltip: false
    };
  },

  computed: {
    listeners() {
      return Object.assign({}, this.$listeners, {
        change: [this.emitter],
        'click:clear': this.clearFilter
      });
    },
    selectedItem() {
      if (this.items && this.items.length && this.value) {
        return this.items.find(el => el.id === this.value);
      } else {
        return {};
      }
    }
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    }
  },

  methods: {
    valueWatchHandler(v) {
      if (!v) {
        this.showTooltip = false;
      }
    },

    clearFilter() {
      this.emitter(this.multiple ? [] : '');
    },

    emitter(data) {
      this.$emit('input', data);
      this.$emit('change', data);
    },

    showCompany() {
      if (!this.selectedItem.id) {
        return;
      }
      this.$router.push({
        name: 'companies.show',
        params: {
          id: this.selectedItem.id
        }
      });
    }
  }
};
</script>
<style lang="scss">
.tooltip-list {
  p {
    margin-bottom: 0;
  }
}
</style>
